import { css, useTheme } from '@fable/theme'
import fortuneLogo from '../../../../assets/images/brands/fortune-logo.webp'
import wiredLogo from '../../../../assets/images/brands/wired-logo.webp'
import { FlexBox, Text } from '@fable/components'

interface TestimonialProps extends React.HTMLProps<HTMLDivElement> {
  quote: string
  image: string
  name: string
}

const testimonials = [
  {
    quote: 'A more thoughtful—and less toxic—social media app for book lovers',
    image: fortuneLogo,
    name: 'Fortune',
  },
  {
    quote: 'There’s a good chance your favorite BookToker has a club on Fable',
    image: wiredLogo,
    name: 'Wired',
  },
]

const Testimonial: React.VFC<TestimonialProps> = ({
  className,
  quote,
  image,
  name,
}) => (
  <FlexBox className={className} flexDirection="column" centerAll>
    <Text
      className={css`
        max-width: 330px;
      `}
      type="body"
      sizing="XL"
    >
      &ldquo;{quote}&rdquo;
    </Text>
    <img
      className={css`
        margin-top: 24px;
        display: block;
        height: 22px;
        width: auto;
      `}
      src={image}
      alt={`${name} logo`}
    />
  </FlexBox>
)

export const DownloadAppCardTestimonials: React.VFC = () => {
  const { mediaQueries } = useTheme()

  return (
    <div
      className={css`
        text-align: center;
        margin-top: 48px;
      `}
    >
      {testimonials.map((testimonal: TestimonialProps, i: number) => (
        <Testimonial
          className={css`
            margin-bottom: 36px;
            ${mediaQueries.desktop} {
              margin-bottom: 0;
              display: ${i !== 0 ? 'none' : 'flex'};
            }
          `}
          key={i}
          {...testimonal}
        />
      ))}
    </div>
  )
}
